import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { Vendor } from "../types";

interface VendorFiltersProps {
  vendors: Vendor[];
  filterCity?: string;
  filterType?: string;
  setFilterCity?: (city: string) => void;
  setFilterType?: (type: string) => void;
}
const VendorFilters: React.FC<VendorFiltersProps> = ({
  vendors,
  filterCity = "",
  filterType = "",
  setFilterCity = () => {},
  setFilterType = () => {},
}) => {
  const cities = [...new Set(vendors.map((v) => v.located).filter(Boolean))];

  const types = [...new Map(vendors.map((v) => [v.type?.id, v.type])).values()];

  const isDesktop = useMediaQuery("(min-width: 720px)");

  return (
    <Stack direction={isDesktop ? "row" : "column"} spacing={2} mb={2}>
      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>By</InputLabel>
        <Select
          value={filterCity}
          onChange={(e) => setFilterCity(e.target.value)}
        >
          <MenuItem value="">Alle</MenuItem>
          {cities.map((city) => (
            <MenuItem key={city} value={city}>
              {city}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Type</InputLabel>
        <Select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <MenuItem value="">Alle</MenuItem>
          {types
            .filter((t): t is NonNullable<typeof t> => !!t)
            .map((type) => (
              <MenuItem key={type.id} value={String(type.id)}>
                {type.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default VendorFilters;
